<template>
  <div class="nkn-more">
    <div class="common-sub-title">{{$t("partner.more.title")}}</div>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-4">
        <more-module>
          <img v-lazy="'/static/img/partner/more/Ultra.png'" class="pic-more-Ultra" slot="more-logo">
          <a slot="more-name"  target="_blank">{{$t("partner.more.subtitle1")}}</a>
          <p slot="more-intro">{{$t("partner.more.subContent1")}}</p>
        </more-module>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-4">
        <more-module>
          <img v-lazy="'/static/img/partner/more/Uberized.png'" class="pic-more-Uberized" slot="more-logo">
          <a slot="more-name"  target="_blank">{{$t("partner.more.subtitle2")}}</a>
          <p slot="more-intro">{{$t("partner.more.subContent2")}}</p>
        </more-module>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-4">
        <more-module>
          <img v-lazy="'/static/img/partner/more/Co-build.png'" class="pic-more-Co-built" slot="more-logo">
          <a slot="more-name"  target="_blank">{{$t("partner.more.subtitle3")}}</a>
          <p slot="more-intro">{{$t("partner.more.subContent3")}}</p>
        </more-module>
      </div>
    </div>
  </div>
</template>

<script>
import MoreModule from '@/components/partner/plugins/MoreModule'
export default {
  components: {
    MoreModule
  }
}
</script>

<style lang="scss" scoped>
.nkn-more{
  @include common-inner();
  @media screen and (max-width: 768px){
    img {
      width: 110px;
      height: auto;
    }
  }
  .row{
    margin-top: 2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/partner/nknMore.vue